import { isRetakeCheck, isInProgressCheck } from './parse.js'
import _ from 'lodash'

export function buildLiveRetakeCheck (activity) {
  if (!isRetakeCheck(activity) && (activity.score.activityScore >= activity.score.scoreTarget)) {
    buildRetake(activity, 0, true)
  }
}

export function buildRetake (activity, progress = 0, force = 0) {
  if (!progress && !force) {
    return {}
  }

  // populate new retake
  if ((progress && progress.score >= progress.target && !progress.rt) || force) {
    activity.finalScore = _.cloneDeep(activity.score)
    activity.score.activityScore = 0

    activity.finalScore.final_questions_received = _.clone(activity.studentData.activity_questions_received)
    activity.studentData.activity_questions_received = 0

    // copy final quiz topic performance data to a safe place, then clear it for the retake
    activity.finalScore.allTopics = _.cloneDeep(activity.allTopics)
    activity.finalScore.topics = _.cloneDeep(activity.topics)
    activity.finalScore.hintCount = _.clone(activity.score.hintCount)
    activity.finalScore.completedQuestionCount = _.clone(activity.score.completedQuestionCount)
    activity.score.completedQuestionCount = 0

    for (let i = 0; i < activity.allTopics.length; i++) {
      activity.allTopics[i].questionsReceived = 0
      activity.allTopics[i].nextLevel = 1
      activity.allTopics[i].totalPointsEarned = 0
      activity.allTopics[i].totalPointsAvailable = 0
    }

    for (let i = 0; i < activity.topics.length; i++) {
      activity.topics[i].questionsReceived = 0
      activity.topics[i].nextLevel = 1
      activity.topics[i].totalPointsEarned = 0
      activity.topics[i].totalPointsAvailable = 0
    }

    activity.studentData.isRetake = 1

    if (!isInProgressCheck(activity)) {
      activity.questions = resetQuestionViewData(activity.questions)
    }
  } else if (progress.score >= progress.target && progress.rt) {
    // populate existing retake
    activity.finalScore = _.cloneDeep(activity.score)
    activity.score.activityScore = progress.rt.score
    activity.score.activityGrade = progress.rt.score >= progress.rt.target ? 100 : 0

    activity.finalScore.final_questions_received = _.clone(activity.studentData.activity_questions_received)
    activity.studentData.activity_questions_received = progress.rt.qr

    activity.finalScore.allTopics = _.cloneDeep(activity.allTopics)
    activity.finalScore.topics = _.cloneDeep(activity.topics)

    for (let i = 0; i < activity.allTopics.length; i++) {
      activity.allTopics[i].questionsReceived = progress.rt.tp[i].qr
      activity.allTopics[i].nextLevel = progress.rt.tp[i].nl
      activity.allTopics[i].totalPointsAvailable = progress.rt.tp[i].pa
      activity.allTopics[i].totalPointsEarned = progress.rt.tp[i].pe
    }

    for (let i = 0; i < activity.topics.length; i++) {
      activity.topics[i].questionsReceived = progress.rt.tp[i].qr
      activity.topics[i].nextLevel = progress.rt.tp[i].nl
      activity.topics[i].totalPointsAvailable = progress.rt.tp[i].pa
      activity.topics[i].totalPointsEarned = progress.rt.tp[i].pe
    }

    activity.studentData.isRetake = 1

    if (!isInProgressCheck(activity)) {
      activity.questions = resetQuestionViewData(activity.questions)
    }
  }
}

export const resetQuestionViewData = (questions) => {
  return questions.map(q => _.merge({}, q, {
    timesTested: 0,
    timesCorrect: 0,
    meta: {
      primary_question: q.primary_question ? 'true' : undefined
    }
  }))
}
